// De twee uurtarieven van een organisatie (besluit 9 in
// docs/features/huishouden-vaste-gegevens.md): uitvoering (voorzieningen) en
// advies. Ze staan op CompagnyMeta en rekenen uren om naar besteding in de
// SiSa/SPUK-verantwoording.
//
// NIET INGESTELD IS NIET €0. Een leeg tarief is `null`, en een afnemer toont dan
// 'tarief niet ingesteld' in plaats van een bedrag. 0 is wél een tarief (een
// organisatie die alleen met vrijwilligers werkt).
// AI-CONTEXT: See docs/pitfalls.md#state-or-fallback-erases-zero
// AI-CONTEXT: See docs/pitfalls.md#ui-aggregate-collapses-nothing-into-zero

/** Veldnamen op CompagnyMeta. */
const HOURLY_RATE_FIELDS = {
    uitvoering: 'UurtariefUitvoering',
    advies: 'UurtariefAdvies',
}

const FOUT = 'Vul een bedrag in, zoals 35 of 42,50.'

/**
 * @param {string} raw - Wat de gebruiker typte
 * @returns {{value: number|null}|{error: string}}
 */
const parseHourlyRate = (raw) => {
    const text = String(raw ?? '').replace('€', '').trim()
    if (!text) return { value: null }
    // Eén scheidingsteken, hooguit twee decimalen. '1.250,00' weigeren we liever
    // dan te raden of de punt duizendtallen of decimalen scheidt.
    if (!/^\d+([.,]\d{1,2})?$/.test(text)) return { error: FOUT }
    return { value: Number(text.replace(',', '.')) }
}

/**
 * @param {*} value
 * @returns {number|null}
 */
const rateOf = (value) => (typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null)

/**
 * @param {object} [meta] - Het CompagnyMeta-document
 * @returns {{uitvoering: number|null, advies: number|null}}
 */
const readHourlyRates = (meta) => ({
    uitvoering: rateOf(meta?.[HOURLY_RATE_FIELDS.uitvoering]),
    advies: rateOf(meta?.[HOURLY_RATE_FIELDS.advies]),
})

/**
 * @param {number|null} rate
 * @returns {string} '35,50', '35', of '' als het niet ingesteld is
 */
const formatHourlyRate = (rate) => {
    if (rate === null || rate === undefined) return ''
    return (Number.isInteger(rate) ? String(rate) : rate.toFixed(2)).replace('.', ',')
}

export { HOURLY_RATE_FIELDS, parseHourlyRate, readHourlyRates, formatHourlyRate }
export default readHourlyRates
